
import { defineComponent } from "vue";
import { docs, excels, DOCS_MAP } from "@/constants/docs.constant";

export default defineComponent({
  setup() {
    const basePath =
      window.location.href.split("/").slice(0, 3).join("/") + "/api/docs/";
    
    const getFileExtension = (fileName: string) => {
      const ext = fileName.split(".").pop();
      return ext;
    };

    return {
      docs,
      excels,
      DOCS_MAP,
      basePath,
      getFileExtension
    };
  },
});
